webpackJsonp([142166431648673],{

/***/ 433:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Dual Lands","path":"/badlands"}}}]}},"pathContext":{"tag":"Card Review"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-card-review-48ad158a5925a3b0deb0.js